module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter-number"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "flush-left"
  }, [_vm._v("I’d like to thank Joan Hess for the many mutual plot sessions over a semi-friendly game of backgammon; my long-time reader and even longer-time daughter, Evin Cooper; my stalwart agent, Vicky Bijur, for her input and support; my editor, Sara Porter, for her advice and counsel, and a special thank you to Jan Grape, long-time reader and friend, who invited me to swim with the dolphins.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-185dead2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/ack.vue
// module id = 75
// module chunks = 0